var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAkarIconsCircleDark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50016 0.666626C12.5502 0.666626 15.8335 3.94996 15.8335 7.99996C15.8335 12.05 12.5502 15.3333 8.50016 15.3333C4.45016 15.3333 1.16683 12.05 1.16683 7.99996C1.16683 3.94996 4.45016 0.666626 8.50016 0.666626ZM9.9715 5.80463C10.0929 5.67889 10.1601 5.51049 10.1586 5.33569C10.1571 5.16089 10.087 4.99369 9.96338 4.87008C9.83977 4.74647 9.67256 4.67636 9.49776 4.67484C9.32297 4.67332 9.15456 4.74052 9.02883 4.86196L6.36216 7.52863C6.23718 7.65364 6.16697 7.82318 6.16697 7.99996C6.16697 8.17673 6.23718 8.34627 6.36216 8.47129L9.02883 11.138C9.15456 11.2594 9.32297 11.3266 9.49776 11.3251C9.67256 11.3236 9.83977 11.2534 9.96338 11.1298C10.087 11.0062 10.1571 10.839 10.1586 10.6642C10.1601 10.4894 10.0929 10.321 9.9715 10.1953L7.77616 7.99996L9.9715 5.80463Z",
    fill: "#925048"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAkarIconsCircleDark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/akar-icons_circle_dark.ebe9226c.svg";
export { ForwardRef as ReactComponent };